// @flow
import React, { type Node } from 'react';
import './EventingTemplate.scss';

type Props = {
  children: Node,
};

const EventingTemplate = ({ children }: Props) => (
  <div className="EventingTemplate">{children}</div>
);

export default EventingTemplate;



// WEBPACK FOOTER //
// ./src/components/eventing/EventingTemplate/EventingTemplate.js